import React from 'react';

export default function Header({ title, children }) {
  return (
    <div className="page-header">
      <h1>{title}</h1>
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        {children}
      </div>
    </div>
  );
}
